const youtube = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/FooterAssets/youtube.webp',
  linkedin = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/FooterAssets/linkedin.webp',
  // Logolight = 'https://d3t7cnf9sa42u5.cloudfront.net/VC_Website_lighting/websiteAssets/NavAssets/LogoWhite.svg';
  Logolight = 'https://d3t7cnf9sa42u5.cloudfront.net/websiteAssets/NavAssets/LogoWhite.webp';

export { youtube, linkedin, Logolight };
